import React from 'react';
import {Suggestions} from 'components';

export function Values(props) {
  return (
    <Suggestions.List {...props}>
      <p>Meet my life partner and lover</p>
      <p>Be in a committed relationship</p>
      <p>Share my life with the man of my dreams</p>
      <p>Get married to my wonderful girlfriend</p>
      <p>Live with soul mate partner</p>
      <p>Married happily to my sweetheart</p>
      <p>Love</p>
      <p>Health</p>
      <p>Family</p>
      <p>Happiness</p>
      <p>Relationships</p>
      <p>Creativity</p>
      <p>Achievement</p>
      <p>Abundance</p>
      <p>Passion</p>
      <p>Spirituality</p>
      <p>Freedom</p>
      <p>Development</p>
      <p>Giving other</p>
      <p>Caring for others</p>
      <p>Friendship</p>
      <p>Contribution</p>
      <p>Peace</p>
      <p>Charity</p>
      <p>Exploration</p>
      <p>Integrity</p>
      <p>Independence</p>
      <p>Fun and Joy</p>
      <p>Pleasure</p>
      <p>Challenges</p>
      <p>Comfort</p>
      <p>Adventure</p>
      <p>Intimacy</p>
      <p>Wealth</p>
      <p>Kindness</p>
      <p>Excellence</p>
      <p>Leadership</p>
      <p>Truth</p>
      <p>Knowledge</p>
      <p>Security</p>
      <p>Trust</p>
      <p>Religion</p>
      <p>Winning</p>
      <p>Education</p>
    </Suggestions.List>
  );
}
